export default __webpack_public_path__ + "static/media/world.085f641a.svg";